var map = {
	"./de/video-btn.png": "ANkl",
	"./en/video-btn.png": "HHN0",
	"./es/video-btn.png": "VKod",
	"./fr/video-btn.png": "u+eG",
	"./ja/video-btn.png": "3e7i",
	"./ko/video-btn.png": "wr9K",
	"./pt/video-btn.png": "RK6o",
	"./ru/video-btn.png": "eMaH",
	"./tc/video-btn.png": "4PhE",
	"./th/video-btn.png": "OKHW"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "LJOd";